import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n, SUPPORTED_LANGS } from "@/i18n/I18nProvider";

function useCurrentLang() {
  const { pathname } = useLocation();
  const seg = pathname.split("/")[1];
  return SUPPORTED_LANGS.includes(seg) ? seg : "ar";
}

export default function Footer({ onManagePreferences }) {
  const { t } = useI18n();
  const lang = useCurrentLang();
  const base = `/${lang}`;
  const year = new Date().getFullYear();

  return (
    <footer className="dma-footer">
      <div className="dma-footer__grid">
        <div className="dma-footer__brand">
          <Logo />
          <p className="dma-footer__desc">{t("footer.description")}</p>
          <p className="dma-footer__disclaimer">{t("footer.disclaimer")}</p>
        </div>

        <div>
          <h4 className="dma-footer__title">{t("footer.navTitle")}</h4>
          <ul className="dma-footer__list">
            <li>
              <Link to={base}>{t("nav.home")}</Link>
            </li>
            <li>
              <a href={`${base}#why`}>{t("nav.whyChoose")}</a>
            </li>
            <li>
              <a href={`${base}#how`}>{t("nav.howItWorks")}</a>
            </li>
            <li>
              <a href={`${base}#transparency`}>{t("nav.transparency")}</a>
            </li>
            <li>
              <a href={`${base}#contact`}>{t("nav.contact")}</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="dma-footer__title">{t("footer.legalTitle")}</h4>
          <ul className="dma-footer__list">
            <li>
              <Link to={`${base}/privacy`}>{t("footer.privacy")}</Link>
            </li>
            <li>
              <Link to={`${base}/cookies`}>{t("footer.cookies")}</Link>
            </li>
            <li>
              <Link to={`${base}/terms`}>{t("footer.terms")}</Link>
            </li>
            <li>
              <button type="button" className="dma-footer__linkbtn" onClick={onManagePreferences}>
                {t("footer.managePreferences")}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="dma-footer__title">{t("footer.contactTitle")}</h4>
          <ul className="dma-footer__list">
            <li>
              <a href={`mailto:${t("footer.email")}`}>{t("footer.email")}</a>
            </li>
            <li>
              <a href={`tel:${t("footer.phone").replace(/\s/g, "")}`}>{t("footer.phone")}</a>
            </li>
            <li className="dma-footer__address">{t("footer.address")}</li>
          </ul>
        </div>

        <div className="dma-footer__company">
          <h4 className="dma-footer__title">{t("footer.companyTitle")}</h4>
          <dl className="dma-footer__dl">
            <div>
              <dt>{t("footer.cuitLabel")}</dt>
              <dd>{t("footer.cuitValue")}</dd>
            </div>
            <div>
              <dt>{t("footer.registryLabel")}</dt>
              <dd>{t("footer.registryValue")}</dd>
            </div>
            <div>
              <dt>{t("footer.licenseLabel")}</dt>
              <dd>{t("footer.licenseValue")}</dd>
            </div>
            <div>
              <dt>{t("footer.jurisdictionLabel")}</dt>
              <dd>{t("footer.jurisdictionValue")}</dd>
            </div>
            <div>
              <dt>{t("footer.incorporationLabel")}</dt>
              <dd>{t("footer.incorporationValue")}</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="dma-footer__bottom">
        <span>
          © {year} {t("footer.companyLegalName")} · {t("footer.rights")}
        </span>
      </div>
    </footer>
  );
}
